import { render } from "./TextCarousel.vue?vue&type=template&id=53cdc50b&scoped=true"
import script from "./TextCarousel.vue?vue&type=script&lang=js"
export * from "./TextCarousel.vue?vue&type=script&lang=js"

import "./TextCarousel.vue?vue&type=style&index=0&id=53cdc50b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cdc50b"]])

export default __exports__